import React, { memo, useRef, useState, useEffect } from 'react'
import { indexOfSlot } from 'tve/components/appointment_grid/desktop/hooks'

const checkOverflow = (elem) => {
  const elemHeight = elem.getBoundingClientRect().height
  const parentHeight = elem.parentElement.getBoundingClientRect().height
  return elemHeight > parentHeight
}

const Holiday = memo(({ addLegend, legends, slot }) => {
  if (!slot.firstHoliday) return null

  const { holidayCount, holidayName } = slot
  const legendIndex = indexOfSlot(slot, legends)

  const [isOverflowing, setIsOverflowing] = useState(false)

  const el = useRef(undefined)

  useEffect(() => {
    const overflowing = checkOverflow(el.current)
    setIsOverflowing(overflowing)
    if (overflowing) {
      addLegend(slot)
    }
  }, [slot])

  const className = ['atp-time-table__holiday']
  if (isOverflowing) className.push('atp-time-table__holiday--too-long')

  return (
    <td rowSpan={holidayCount}>
      <div className={className.join(' ')} data-legend={legendIndex >= 0 ? legendIndex + 1 : null}>
        <div className="atp-time-table__holiday__label" ref={el}>
          {holidayName}
        </div>
      </div>
    </td>
  )
})

Holiday.displayName = 'Holiday'

export default Holiday
